import { Model } from 'pinia-orm';

export enum ProjectUserSessionStatus {
  NEW = 'new',
  PENDING = 'pending',
  AUTHORIZED = 'authorized',
  BLOCKED = 'blocked',
}

export interface IProjectUserSession {
  id: number;
  projectId: number;
  userId: number;
  userAgent: string;
  ip: string;
  status: ProjectUserSessionStatus;
  lastActivity: number;
  isCurrent: boolean;
}

export class ProjectUserSession extends Model implements IProjectUserSession {
  static override entity = 'orm/projectUserSessions';

  static override fields() {
    return {
      id: this.attr(null),
      projectId: this.attr(null),
      userId: this.attr(null),
      userAgent: this.attr(null),
      ip: this.attr(null),
      status: this.attr(null),
      lastActivity: this.attr(null),
      isCurrent: this.attr(null),
    };
  }

  declare id: number;
  declare projectId: number;
  declare userId: number;
  declare userAgent: string;
  declare ip: string;
  declare status: ProjectUserSessionStatus;
  declare lastActivity: number;
  declare isCurrent: boolean;
}
